export default __webpack_public_path__ + "src/assets/gridplus.354631c721c7988327b31d865cd808c7.svg";